export enum PayzenStatusEnum {
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    CANCELED = 'CANCELED'
}